module.exports = __webpack_public_path__ + "static/004-3caacbf3a3f91e2c83b7e119a584edcc.jpg";